import { sendRequest } from 'best-modules/vue-utils'
import { Query } from 'best-modules/utils'
import { PaginationList } from 'best-modules/components/server-table/types'
import {
  DocumentTypeFieldDefinition,
  DocumentTypeFieldDefinitionCredentials,
} from '@/utils/types/documentTypeField'

const fieldDefinitionList = (
  query: Query
): Promise<PaginationList<DocumentTypeFieldDefinition>> => {
  return sendRequest({
    name: 'fieldDefinitionList',
    method: 'get',
    url: {
      url: '/json/doc-type/field',
      query,
    },
  })
}

const fieldDefinitionSingle = (
  id: number
): Promise<DocumentTypeFieldDefinition> => {
  return sendRequest({
    name: 'fieldDefinitionSingle',
    method: 'get',
    url: `/json/doc-type/field/single/${id}`,
  })
}

const fieldDefinitionCreate = (
  data: DocumentTypeFieldDefinitionCredentials
): Promise<DocumentTypeFieldDefinition> => {
  return sendRequest({
    name: 'fieldDefinitionCreate',
    method: 'post',
    url: '/json/doc-type/field/create',
    payload: data,
  })
}

const fieldDefinitionUpdate = (
  id: number,
  data: DocumentTypeFieldDefinitionCredentials
): Promise<DocumentTypeFieldDefinition> => {
  return sendRequest({
    name: 'fieldDefinitionUpdate',
    method: 'post',
    url: `/json/doc-type/field/update/${id}`,
    payload: data,
  })
}

const fieldDefinitionDeactivate = (
  id: number
): Promise<DocumentTypeFieldDefinition> => {
  return sendRequest({
    name: 'fieldDefinitionDeactivate',
    method: 'post',
    url: `/json/doc-type/field/deactivate/${id}`,
  })
}

const fieldDefinitionActivate = (
  id: number
): Promise<DocumentTypeFieldDefinition> => {
  return sendRequest({
    name: 'fieldDefinitionActivate',
    method: 'post',
    url: `/json/doc-type/field/activate/${id}`,
  })
}

export {
  fieldDefinitionList,
  fieldDefinitionSingle,
  fieldDefinitionCreate,
  fieldDefinitionUpdate,
  fieldDefinitionDeactivate,
  fieldDefinitionActivate,
}
